import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-date-offset-picker',
    templateUrl: './date-offset-picker.component.html',
    styleUrls: ['./date-offset-picker.component.scss'],
    imports: [
        FormsModule
    ]
})
export class DateOffsetPickerComponent {

    @Input() title: string;
    @Input() headline: string;
    @Input() descriptionPre: string;
    @Input() descriptionPost: string;
    @Input() cancelText: string;
    @Input() confirmText: string;
    @Input() initialValue: number = 2;

    private selectedValue: number;
    public valueSelection: Subject<number> = new Subject();

    constructor(public bsModalRef: BsModalRef) { }

    close() {
        this.valueSelection.next(this.initialValue);
        this.bsModalRef.hide();
    }

    confirm() {
        this.valueSelection.next(this.selectedValue);
        this.bsModalRef.hide();
    }

    set(value: string) {
        this.selectedValue = parseInt(value);
    }
}
